var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scheduled meeting/User_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 45",
    d: "M54.7681 54.032C55.1376 53.7792 55.3008 53.3055 55.1361 52.8892C53.7193 49.3089 51.3785 47.1854 47.3918 44.806C43.1479 42.2732 37.9481 40.9004 32.5989 40.9004C27.2496 40.9004 22.0498 42.2732 17.806 44.806C13.8188 47.1856 11.478 49.6623 10.0612 53.2859C9.89793 53.7035 10.059 54.1738 10.4321 54.4225C23.8256 63.3516 41.4831 63.1217 54.7681 54.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 46",
    cx: 32.5996,
    cy: 22,
    rx: 13.5,
    ry: 13.5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFill);
export default __webpack_public_path__ + "static/media/User_fill.195aad4f2d23cadd9cda65d8a34c41f0.svg";
export { ForwardRef as ReactComponent };